/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Method_CashInputs */

const vi_cashflow_method_cash = /** @type {(inputs: Cashflow_Method_CashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền mặt`)
};

/**

* @param {Cashflow_Method_CashInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_method_cash = /** @type {((inputs?: Cashflow_Method_CashInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Method_CashInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_method_cash(inputs)
});